import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { fetchSchoolById } from '../../services2/pschools.service';
import { fetchMissionById } from '../../services2/pmissions.service';
import { adminFetchStudentMissions } from '../../services2/pstudentMissions.service';
import StudentAbilityPoints from './components/StudentAbilityPoints';

function Component(props) {
    const { id,missionId } = useParams();
    const navigate = useNavigate();
    let [searchParams, setSearchParams] = useSearchParams();
    const [data, setdata] = useState([])
    const [isLoading, setisLoading] = useState(false)
    const [total, settotal] = useState(0)
    const [mission, setmission] = useState(null)

    const page = parseInt(searchParams.get('page')) || 1;
    const limit =999


    const fetchData = async () => {
        const filter = { _id:id, status: '已完成' }
        let result = await adminFetchStudentMissions(props.token.token, filter, { limit, skip: (page - 1) * limit });
        if (result.result) {
            setdata(result?.result)
            settotal(result?.count || 0)
        } else {
            alert('Fetch data error 1')
        }
    }


    const fetchMissionData = async () => {
        let result = await fetchMissionById(props.token.token, missionId);
        if (result.result) {
            setmission(result.result)
        } else {
            alert('Fetch data error 2: ' + missionId)
        }
    }

    const refresh = async () => {
        setisLoading(true)
        fetchData()
        fetchMissionData()
        setisLoading(false)
    }


    useEffect(() => {
        const timer = setTimeout(refresh, 500)
        // const interval = setInterval(refresh, 1000 * 30)
        return () => {
            clearTimeout(timer)
            // clearInterval(interval)
        }
    }, [searchParams])





    return (
        <StudentAbilityPoints
            data={data}
            mission={mission}
        />
    );
}

export default connect((store) => {
    return {
        token: store.tokenReducer,
    }
})(Component)
